import { useState } from "react";
import { mockDealerLogs, mockAllDealers } from "@/mocks/dealerData";

export default function AdminDealerLogsPage() {
  const [selectedDealer, setSelectedDealer] = useState("");
  const [search, setSearch] = useState("");

  const filtered = mockDealerLogs.filter((log) => {
    if (selectedDealer && log.dealerId !== selectedDealer) return false;
    if (search) {
      const q = search.toLowerCase();
      return log.action.toLowerCase().includes(q) || log.detail.toLowerCase().includes(q) || log.dealerName.toLowerCase().includes(q);
    }
    return true;
  });

  return (
    <div className="max-w-7xl mx-auto">
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-6">
        <div>
          <h4 className="text-lg font-semibold text-foreground-950"><a id="dealer-logs">Bayi Logları</a></h4>
          <p className="text-sm text-foreground-500 mt-0.5">Bayilerin sistem hareketlerini detaylı izleyin</p>
        </div>
      </div>

      <div className="flex flex-col sm:flex-row gap-3 mb-4">
        <select value={selectedDealer} onChange={(e) => setSelectedDealer(e.target.value)} className="px-3 py-2 bg-background-50 border border-background-200/70 rounded-lg text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-accent-400">
          <option value="">Tüm Bayiler</option>
          {mockAllDealers.map((d) => (<option key={d.id} value={d.id}>{d.dealerName} ({d.dealerCode})</option>))}
        </select>
        <div className="relative flex-1">
          <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
          <input type="text" value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Log ara..." className="w-full pl-9 pr-3 py-2 bg-background-50 border border-background-200/70 rounded-lg text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-accent-400" />
        </div>
      </div>

      <div className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden">
        {/* Desktop Table */}
        <div className="overflow-x-auto hidden md:block">
          <table className="w-full text-sm min-w-[650px]">
            <thead>
              <tr className="bg-background-100 text-left">
                <th className="px-4 py-3 text-xs font-medium text-foreground-500">Tarih</th>
                <th className="px-4 py-3 text-xs font-medium text-foreground-500">Bayi</th>
                <th className="px-4 py-3 text-xs font-medium text-foreground-500">İşlem</th>
                <th className="px-4 py-3 text-xs font-medium text-foreground-500">Detay</th>
                <th className="px-4 py-3 text-xs font-medium text-foreground-500">IP</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((log) => (
                <tr key={log.id} className="border-t border-background-200/70 hover:bg-background-100/50 transition-colors">
                  <td className="px-4 py-3 text-foreground-600 text-xs">{new Date(log.date).toLocaleString("en-US")}</td>
                  <td className="px-4 py-3">
                    <span className="font-medium text-foreground-900">{log.dealerName}</span>
                  </td>
                  <td className="px-4 py-3">
                    <span className={`inline-flex px-2 py-0.5 rounded-full text-xs font-medium ${
                      log.action === "Satış" ? "bg-primary-100 text-primary-700" :
                      log.action === "Giriş" ? "bg-secondary-100 text-secondary-700" :
                      log.action === "Çıkış" ? "bg-foreground-100 text-foreground-600" :
                      "bg-accent-100 text-accent-700"
                    }`}>{log.action}</span>
                  </td>
                  <td className="px-4 py-3 text-foreground-600 text-xs max-w-xs truncate">{log.detail}</td>
                  <td className="px-4 py-3 text-foreground-400 text-xs">{log.ip}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Mobile Cards */}
        <div className="md:hidden divide-y divide-background-200/70">
          {filtered.map((log) => (
            <div key={log.id} className="p-4">
              <div className="flex items-start justify-between mb-1">
                <span className={`inline-flex px-2 py-0.5 rounded-full text-xs font-medium ${
                  log.action === "Satış" ? "bg-primary-100 text-primary-700" :
                  log.action === "Giriş" ? "bg-secondary-100 text-secondary-700" :
                  log.action === "Çıkış" ? "bg-foreground-100 text-foreground-600" :
                  "bg-accent-100 text-accent-700"
                }`}>{log.action}</span>
                <span className="text-xs text-foreground-400">{new Date(log.date).toLocaleString("en-US")}</span>
              </div>
              <p className="text-sm font-medium text-foreground-900 mb-1">{log.dealerName}</p>
              <p className="text-xs text-foreground-500 mb-2">{log.detail}</p>
              <p className="text-xs text-foreground-400">IP: {log.ip}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}